//
//service to handle extractions via the workareaservice
//includes options such as enableFTS

(function () {
    'use strict';

    angular
        .module('app')
        .factory('extractionservice', extractionservice);

    //2018 SP1 Refactor: 20180827 - GT
    //removed workareaservice from injection and included willextract and extractitem and clientservice to this service
    extractionservice.$inject = ['$http', '$q', '$filter', '$timeout', 'clientService'];

    function extractionservice($http, $q, $filter, $timeout, clientService) {
        var service = {
            extractingText: extractingText,
            extractItem: extractItem,
            extractWAItem: extractWAItem,
            extractionRequired: extractionRequired,
            extractionItem: { tableNumber: "", filePNE: "", libId: "", fileId: "", fileMajRev: "", fileMinRev: "" },
            pluginDefinitions: [],
            getPluginDefinitions: getPluginDefinitions,
            releasePluginApplications: releasePluginApplications,
            updateExtractedData: updateExtractedData,
            willExtract: willExtract,
            checkFTSExtract: checkFTSExtract,
            clearExtractedData: clearExtractedData
        };

        return service;

        //return true/false as to whether the library (libid) is extracting text
        function extractingText(libId) {
            var deferred = $q.defer();
            var extract = false;

            //look up the lib properties to determine FTS option
            if (libId != null && libId.length > 0) {

                //check for ADEPT_NULL_LIBID
                if (libId == "ADEPT_NULL_LIBID")
                    deferred.resolve(false);

                //get the lib properties
                //if extract text on, set extractText to 1

                //put libid into list b/c that's what the calling function expects
                var libIdList = [libId];

                //call the local function to check fts
                ftsEnabled(libIdList).then(function (response) {
                    if (response != null) {
                        //response is a dictionary of string, bool (libid, ftsenabled)
                        extract = response[libId];
                    }
                    else {
                        extract = false;
                    }

                    deferred.resolve(extract);
                }, function (error) {
                    //ftsEnabled failure
                    deferred.reject;
                })
            }
            else {
                deferred.resolve(false);
            }
            return deferred.promise;
        }

        //make the call to determine if extraction is required
        function extractionRequired(tableNumber, fileId, majRev, minRev, libId, lastWriteUTC) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Document/requiresextraction/'.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + '/' + libId + "/" + lastWriteUTC);
            var request = $http.get(url);
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        };

        //make the call to ACS to release application objects for plugins used in extractions
        //2018SP1 Refactor: 20180824 - GT
        function releasePluginApplications() {
            var deferred = $q.defer();
            var extractUrl = 'document/release';
            getPluginDefinitions().then(function (pluginDefinitions) {
                clientService.put(extractUrl).then(function (response) {
                    deferred.resolve(response);
                }, function (error) {
                    deferred.reject(error);
                });
            });
            return deferred.promise;
        }
        
        //using the incoming library id, determine if the library is fts enabled
        function ftsEnabled(libraryIdList) {
            var deferred = $q.defer();
            //expecting List<string> adeptLibraryIds 
            var url = '../Synergis.WebApi/api/Library/FTSEnabled';
            var request = $http({
                url: url,
                method: 'POST',
                data: JSON.stringify(libraryIdList),
                headers: {
                    "Content-Type": "application/json"
                }

            }).then(function (response) {
                deferred.resolve(response.data);

            }, function (err, status) {
                deferred.reject(err);
            });

            //return the promise
            return deferred.promise;
        }

        //2018 SP1: 20180828 - GT
        //moved from workareaservice
        function checkFTSExtract(libIds) {
            var d = $q.defer();

            var request = $http({
                url: '../Synergis.WebApi/api/library/ftsenabled',
                method: 'POST',
                data: JSON.stringify(libIds),
                headers: {
                    "Content-Type": "application/json"
                }
            });


            request.then(function (response) {
                console.log(response);
                d.resolve(response);
            }, function (error) {
                d.reject(error);
            });
            return d.promise;
        }

        //2018 SP1 Refactor: 20180828 - GT
        //Moved from workareaservice
        function updateExtractedData(extractedData) {
            //var deferred = $q.defer();
            var url = "../Synergis.WebApi/api/Document/UpdateExtractionData/";
            var reqData = JSON.stringify(extractedData);

            return $http({
                url: url,
                method: 'POST',
                data: reqData,
                headers: {
                    "Content-Type": "application/json"
                }
            });
        }

        //2018 SP1 Refactor: 20180828 - GT
        //Moved from workareaservice
        function getPluginDefinitions() {
            var deferred = $q.defer();
            if (service.pluginDefinitions.length == 0) {
                $http.get('../Synergis.WebApi/api/Plugins/GetDefinitions/0').then(function (response) {
                    var pluginDefinitions = $filter('filter')(response.data, { loadOnStartUp: true }, true);
                    service.pluginDefinitions = pluginDefinitions;
                    deferred.resolve(pluginDefinitions);
                }, function (error) {
                    deferred.reject(error);
                });
            }
            else {
                deferred.resolve(service.pluginDefinitions);
            }

            return deferred.promise;
        }

        //2018 SP1 Refactor: 20180828 - GT
        //Moved from workAreaService 
        // Bill 11/30/20-17 #24034 AWC-Extraction message showing when not extracting file
        // Call the will extract service from ACS passing in plugin definitions and list of WorkAreaDBRecordModel
        function willExtract(workAreaModel, items) {
            var deferred = $q.defer();
            var requestData = { PluginDefinitions: service.pluginDefinitions, Items: items }
            clientService.put('document/willExtract', requestData).then(function (response) {
                if (response)
                    deferred.resolve(response);
                else
                    deferred.reject();
            });
            return deferred.promise;
        }

        //2018 SP1 Refactor: 20180828 - GT
        //Moved this function from workAreaService as extractItem and renamed here to extractWAItem
        //TODO: Can we incorporate this functionality into the extractItem function for extractionservice
        function extractWAItem(filePNE, extractText) {
            var deferred = $q.defer();
            var extractUrl = 'document/extract?path=' + encodeURIComponent(filePNE) + '&extractText=' + extractText;
            //extractUrl = extractUrl.replace(/#/g, '%23');
            getPluginDefinitions().then(function (pluginDefinitions) {
                clientService.put(extractUrl, pluginDefinitions).then(function (response) {
                    deferred.resolve(response);
                }, function (error) {
                    deferred.reject(error);
                });
            });
            return deferred.promise;
        }

        //2018 SP1 Refactor: 20180828 - GT
        //Moved from selectionCommandService
        function clearExtractedData(
            tableNumber, fileId, majRev, minRev,
            bFields, bExtended, bRelationships, bThumbnail, bFTS, bExtractionState, fields) {

            //define the component types for the extraction model
            var ComponentType_Main_Rec = 0;
            var ComponentType_FullTextSearch = 1;
            var ComponentType_Thumbnail = 2;
            var ComponentType_ExternalReferences = 3;
            var ComponentType_ExtendedRecords = 4;
            var ComponentType_ExtractionState = 5;

            //initialize the extraction data model
            var extractionDataModel = { AdeptTableNumber: tableNumber, AdeptFileId: fileId, AdeptMajorRevision: majRev, AdeptMinorRevision: minRev, MappedExtractionFields: fields };
            extractionDataModel.ExtractionComponents = [];
            if (bFields)
                extractionDataModel.ExtractionComponents.push({ ExtractionComponentType: ComponentType_Main_Rec });
            if (bRelationships)
                extractionDataModel.ExtractionComponents.push({ ExtractionComponentType: ComponentType_ExternalReferences });
            if (bThumbnail)
                extractionDataModel.ExtractionComponents.push({ ExtractionComponentType: ComponentType_Thumbnail });

            // As of now, this is not implemented in the back end.
            // The checkbox is hidden in the UI.
            //if (bFTS)
            //    extractionDataModel.ExtractionComponents.push({ ExtractionComponentType: ComponentType_FullTextSearch });

            // Extended Records are piggy backed off the Properties check box.
            if (bFields) //if (bExtended) 
                extractionDataModel.ExtractionComponents.push({ ExtractionComponentType: ComponentType_ExtendedRecords });

            if (bExtractionState)
                extractionDataModel.ExtractionComponents.push({ ExtractionComponentType: ComponentType_ExtractionState });

            var url = '../Synergis.WebApi/api/Document/ClearExtractionData';
            var request = $http({
                url: url,
                method: 'POST',
                data: JSON.stringify(extractionDataModel),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        //extract the incoming item
        //The isNew parameter is used because if NEW, we check minor revision to consider Out From Library
        function extractItem(extractionItem, isNew) {

            var deferred = $q.defer();

            //check if we're doing fts extraction
            extractingText(extractionItem.libId).then(function (extractingResponse) {

                //promise to do the extraction and update the data on return
                //2018 SP1 Refactor: 20180829 - GT
                //remove qualifying service from workAreaService.extractItem and change extractItem to extractWAItem 
                extractWAItem(extractionItem.filePNE, extractingResponse).then(function (extractedData) {
                    if (extractedData) {
                        extractedData.AdeptTableNumber = extractionItem.tableNumber;
                        extractedData.AdeptFileId = extractionItem.fileId;
                        extractedData.AdeptMajorRevision = extractionItem.fileMajRev;
                        extractedData.AdeptMinorRevision = extractionItem.fileMinRev;

                        //promise to update the extraction data and check if a call to a minrev minus one is necessary
                        //2018 SP1 Refactor: 20180829 - GT
                        //remove qualifying service 'workAreaService'
                        updateExtractedData(extractedData).then(function (response) {

                            if (isNew == true && extractedData.AdeptMinorRevision > 1) {
                                //check minrev - if it's greater than .1, update both .1 and the .2 (this is true for NEW/Out From Library)
                                extractedData.AdeptMinorRevision = extractionItem.fileMinRev - 1;
                                extractedData.UpdateLastWriteUTC = false;

                                //if another update is required, promise to do it
                                //2018 SP1 Refactor: 20180829 - GT
                                //remove qualifying service 'workAreaService'
                                updateExtractedData(extractedData).then(function (response) {
                                    //resolve the promise for the additional item if required
                                    deferred.resolve();
                                });
                            }
                            else {
                                //resolve the promise for the first item
                                deferred.resolve();
                            }
                        });
                    }
                    else {
                        deferred.resolve();
                    }
                },
                    function (error) {
                        //extractionItem failed
                        deferred.reject(error);
                    });

                //return the promise
                return deferred.promise;
            })
            return deferred.promise;
        };
    };
})();